import { isDefined } from "@clipboard-health/util-ts";

/**
 * The additional pay a shift earns because a pre-shift orientation extended its
 * worked duration. Returns 0 when no orientation applies, so callers can
 * unconditionally add the result to an original pay amount.
 */
export function getOrientationPayDelta(params: {
  hourlyPay: number;
  hasPreShiftOrientation: boolean;
  orientationLengthInMinutes: number | undefined;
}): number {
  const { hourlyPay, hasPreShiftOrientation, orientationLengthInMinutes } = params;
  if (!hasPreShiftOrientation || !isDefined(orientationLengthInMinutes)) {
    return 0;
  }
  return hourlyPay * (orientationLengthInMinutes / 60);
}
